import React from 'react';

const TextSection = ({ title, paragraphs, titleFontSize = 24, textFontSize = 16 }) => {
  const baseTextStyle = {
    fontSize: textFontSize,
    lineHeight: '24px',
    
    marginBottom: 20,
    color: '#212121',
    fontWeight: 400
  };

  const titleStyle = {
    fontSize: titleFontSize,
    fontWeight: 600,
    marginBottom: 16,
    
    color: '#212121'
  };

  return (
    <div style={{ marginBottom: 48 }}>
      {title && <h3 style={titleStyle}>{title}</h3>}
      {paragraphs.map((text, index) => (
        <p key={index} style={baseTextStyle}>
          {text}
        </p>
      ))}
    </div>
  );
};

export default TextSection;
